module.exports = __webpack_public_path__ + "static/img/areaB_3.b2bb189.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_3.png
// module id = 1275
// module chunks = 1